import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines multiple class values into a single string, resolving Tailwind CSS conflicts.
 *
 * @param inputs - An array of class values (strings, arrays, or objects).
 * @returns A merged string of class names.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Get the correct API base URL based on environment
 * Always use the production API URL for both development and production
 */
export function getApiBaseURL(): string {
  return import.meta.env.VITE_API_URL || "https://api.locuno.com";
}

/**
 * Get the correct redirect URI for OAuth based on environment
 * In development, use localhost:3000
 * In production, use locuno.com
 */
export function getOAuthRedirectUri(): string {
  if (import.meta.env.MODE === "development") {
    return "http://localhost:3000/auth/callback";
  }

  return "https://locuno.com/auth/callback";
}
